<template>
  <div class="nrs-main-view">
    <div class="nrs-container">
      <div class="nrs-page-header" style="margin-bottom: 5px">
        {{ L("TermsOfService.Title.Page") }}
      </div>
      <div class="nrs-page-body">
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section1.SectionHeader") }}
        </div>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section1.SubSection1") }}
        </div>

        <p>
          {{ L("TermsOfService.Section1.1") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section1.SubSection2") }}
        </div>

        <p>
          {{ L("TermsOfService.Section1.2.Paragraph1") }}
        </p>
        <p>
          {{ L("TermsOfService.Section1.2.Paragraph2") }}
        </p>
        <p>
          {{ L("TermsOfService.Section1.2.Paragraph3") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section1.SubSection3") }}
        </div>

        <p>
          {{ L("TermsOfService.Section1.3") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section2.SectionHeader") }}
        </div>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section2.SubSection1") }}
        </div>

        <p>
          {{ L("TermsOfService.Section2.1") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section2.SubSection2.SectionHeader") }}
        </div>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section2.SubSection2.SubSection1") }}
        </div>
        <div class="nrs-page-sub-header margin-top-0">
          {{ L("TermsOfService.Title.Section2.SubSection2.SubSection2") }}
        </div>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph1.SubsectionA") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph1.SubsectionB") }}
        </p>

        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section2.SubSection2.SubSection3") }}
        </div>
        <div class="nrs-page-sub-header margin-top-0">
          {{ L("TermsOfService.Title.Section2.SubSection2.SubSection4") }}
        </div>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionA") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionB") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionC") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionD") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionE") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionF") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionG") }}
        </p>
        <p>
          {{ L("TermsOfService.Section2.2.Paragraph2.SubsectionH") }}
        </p>

        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section3.SectionHeader") }}
        </div>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section3.SubSection1") }}
        </div>
        <p>
          {{ L("TermsOfService.Section3.1") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section3.SubSection2") }}
        </div>
        <p>
          {{ L("TermsOfService.Section3.2.Paragraph1") }}
        </p>
        <p>
          {{ L("TermsOfService.Section3.2.Paragraph2") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section3.SubSection3") }}
        </div>
        <p>
          {{ L("TermsOfService.Section3.3") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section3.SubSection4") }}
        </div>
        <p>
          {{ L("TermsOfService.Section3.4") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section4.SectionHeader") }}
        </div>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section4.SubSection1") }}
        </div>
        <p class="nrs-caps">
          {{ L("TermsOfService.Section4.1.Paragraph1Caps") }}
        </p>
        <p class="nrs-caps">
          {{ L("TermsOfService.Section4.1.Paragraph2Caps") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section4.SubSection2") }}
        </div>
        <p class="nrs-caps">
          {{ L("TermsOfService.Section4.2.Paragraph1Caps") }}
        </p>
        <p class="nrs-caps">
          {{ L("TermsOfService.Section4.2.Paragraph2Caps") }}
        </p>
        <p class="nrs-caps">
          {{ L("TermsOfService.Section4.2.Paragraph3Caps") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section5") }}
        </div>
        <p>
          {{ L("TermsOfService.Section5") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section6") }}
        </div>
        <p>
          {{ L("TermsOfService.Section6.Paragraph1") }}
        </p>
        <p>
          {{ L("TermsOfService.Section6.Paragraph2") }}
        </p>
        <p>
          {{ L("TermsOfService.Section6.Paragraph3") }}
        </p>
        <div class="nrs-page-sub-header">
          {{ L("TermsOfService.Title.Section7") }}
        </div>
        <p>
          {{ L("TermsOfService.Section7.Paragraph1") }}
        </p>
        <p>
          {{ L("TermsOfService.Section7.Paragraph2") }}
        </p>
        <p>
          {{ L("TermsOfService.Section7.Paragraph3") }}
        </p>
        <p>
          {{ L("TermsOfService.Section7.Paragraph4") }}
        </p>
        <p>
          {{ L("TermsOfService.Section7.Paragraph5") }}
        </p>
        <p>
          {{L('TermsOfService.Section7.Paragraph6.SubSection1')}}
          <a target="_blank" href="mailto:accounting@netroadshow.com">accounting@netroadshow.com</a>
          {{L('TermsOfService.Section7.Paragraph6.SubSection2')}}
          <a href="tel:404-504-7177">404-504-7177</a>
          {{L('TermsOfService.Section7.Paragraph6.SubSection3')}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { L } from "../modules/translate";

export default {
  name: "TermsOfService",
  data() {
    return {
      L,
    };
  },
};
</script>

<style lang="less" scoped>
*,
:before,
:after {
  box-sizing: border-box;
}

a {
  color: #337ab7;
  text-decoration: none;
}

.nrs-container {
  max-width: 970px;
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.nrs-container {
  display: table;
  padding-left: 5px;
  position: relative;
}

.nrs-main-view {
  padding-top: 88px;
  padding-bottom: 50px;
}

.nrs-main-view .nrs-container {
  justify-content: center;
}

.nrs-page-header {
  font-size: 24px;
  font-weight: 500;
  color: #285298;
  padding-bottom: 3px;
  margin-bottom: 15px;
}

.nrs-page-body {
  padding-bottom: 30px;
  line-height: 1.75;
}

.nrs-page-sub-header {
  font-size: 18px;
  font-weight: 700;
  color: #285298;
  padding-bottom: 5px;
  margin-top: 30px;
  margin-bottom: -10px;
}

.nrs-caps {
  text-transform: uppercase;
}

.nrs-page-sub-section-header {
  color: #2f5496;
  font-size: 16px;
  margin-bottom: -10px;
  margin-top: 15px;
}

.margin-top-0 {
  margin-top: 0px;
}
</style>
